// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zwFT","content":"styles_content__1KY4A"};